export default __webpack_public_path__ + "static/media/github.d33834de.svg";